import React from "react";
import moment from 'moment';
import { Line } from "react-chartjs-2";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const LineGraph = (props) => {
  const {revenue_overview} = props;
  const screens = useBreakpoint();
  
    return <div className="p-1">
    <Line
      data={{
        labels: revenue_overview.map((item)=>moment(item.timestamp).format('ll')),
        datasets: [
          {
            label: "Sales ",
            data: revenue_overview.map((item)=>item.revenue || item.sales),
            backgroundColor: [
              "rgba(75,192,192,1)",
              "#50AF95",
              "#f3ba2f",
              "#2a71d0"
            ],
            borderColor: "red",
            borderWidth: 2
          }
        ]
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: "Users Gained between 2016-2020"
          },
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false, 
            },
          },
          y: {
            grid: {
              display: true, 
            },
            ticks: {
              maxTicksLimit: 3,
            },
            beginAtZero: true,
          },
        },
      }}
      height={screens.md ? 350 : 250} 
      width={600}
    />
</div>
};
export default LineGraph;